module.exports = __webpack_public_path__ + "static/media/pay-cash-brown.af5d4403.svg";